import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { path: '/', label: '首页' },
    { path: '/category/all', label: '电影分类' },
    { path: '/category/action', label: '动作片' },
    { path: '/category/comedy', label: '喜剧' },
    { path: '/category/scifi', label: '科幻' },
    { path: '/about', label: '关于我们' },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <span className="text-2xl font-heading font-bold text-primary-500 whitespace-nowrap">
              小草影院
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm whitespace-nowrap transition-colors duration-200 ${
                  isActive(link.path)
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索电影..."
                className="w-48 text-sm px-4 py-2 rounded-full bg-background-100 border border-background-200 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 text-foreground-700 placeholder-foreground-400 transition-all"
              />
              <button className="absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" aria-label="搜索">
                <i className="ri-search-line text-sm"></i>
              </button>
            </div>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <nav className="flex flex-col px-4 py-4 gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-3 text-sm rounded-lg transition-colors ${
                  isActive(link.path)
                    ? 'bg-primary-50 text-primary-600 font-medium'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="px-3 pt-2">
              <input
                type="text"
                placeholder="搜索电影..."
                className="w-full text-sm px-4 py-2.5 rounded-full bg-background-100 border border-background-200 focus:outline-none focus:border-primary-300 text-foreground-700 placeholder-foreground-400"
              />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}